import { NegativeNumFormatType, NumberFormatType } from '../../../../sheet/types';
import { SiAutomattic } from 'react-icons/si';
import { TbListNumbers, TbMath1Divide2, TbUserCode } from 'react-icons/tb';
import { AiOutlinePercentage, AiOutlineCalculator } from 'react-icons/ai';
import { TbMathSymbols } from 'react-icons/tb';
import { BsCalendarDate, BsCurrencyDollar } from 'react-icons/bs';
import { VscSymbolString } from 'react-icons/vsc';
import { CiTimer } from 'react-icons/ci';
import { RxLapTimer } from 'react-icons/rx';
import { MdOutlineMotionPhotosAuto } from 'react-icons/md';

export const getVisibleNegativeFormat = (
  formatType: NegativeNumFormatType | string
) => {
  switch (formatType) {
    case NegativeNumFormatType.StandardWithSign:
      return '-1234';
    case NegativeNumFormatType.NegativeAsRed:
      return '1234';
    case NegativeNumFormatType.NegativeAsRedWithSign:
      return '-1234';
    case NegativeNumFormatType.NegativeInBrackets:
      return '(1234)';
    case NegativeNumFormatType.NegativeAsRedInBrackets:
      return '(1234)';
  }
};

export const getIconForFormatType = (
  formatType: NumberFormatType | string
) => {
  switch (formatType) {
    case NumberFormatType.Automatic:
      return MdOutlineMotionPhotosAuto; //SiAutomattic;
    case NumberFormatType.Number:
      return TbListNumbers;
    case NumberFormatType.Percent:
      return AiOutlinePercentage;
    case NumberFormatType.Currency:
      return BsCurrencyDollar;
    case NumberFormatType.Accounting:
      return AiOutlineCalculator;
    case NumberFormatType.DateNTime:
      return BsCalendarDate;
    case NumberFormatType.Duration:
      return RxLapTimer;
    case NumberFormatType.Fraction:
      return TbMath1Divide2;
    case NumberFormatType.Scientific:
      return TbMathSymbols;
    case NumberFormatType.Text:
      return VscSymbolString;
    case NumberFormatType.Custom:
      return TbUserCode;
    default:
      return VscSymbolString;
  }
};

export const getTitleForFormatType = (
  formatType: NumberFormatType | string
) => {
  switch (formatType) {
    case NumberFormatType.Automatic:
      return 'Automatic'; //SiAutomattic;
    case NumberFormatType.Number:
      return 'Number';
    case NumberFormatType.Percent:
      return 'Percent';
    case NumberFormatType.Currency:
      return 'Currency';
    case NumberFormatType.Accounting:
      return 'Accounting';
    case NumberFormatType.DateNTime:
      return 'Date and Time';
    case NumberFormatType.Duration:
      return 'Duration';
    case NumberFormatType.Fraction:
      return 'Fraction';
    case NumberFormatType.Scientific:
      return 'Scientific';
    case NumberFormatType.Text:
      return 'Text';
    case NumberFormatType.Custom:
      return 'Custom';
    default:
      return 'Number Format';
  }
};


export const numberFormatTabs = Object.values(NumberFormatType)
  .filter((val) => !isNaN(Number(val)))
  .map(
    (formatType) => ({
      title: getTitleForFormatType(formatType),
      Icon: getIconForFormatType(formatType),
      formatType,
    })
  );
// export const numberFormatTabs = [
//   {
//     title: getTitleForFormatType(NumberFormatType.Automatic),
//     Icon: getIconForFormatType(NumberFormatType.Automatic),
//     formatType: NumberFormatType.Automatic,
//   },
//   {
//     title: 'Number',
//     Icon: getIconForFormatType(NumberFormatType.Number),
//     formatType: NumberFormatType.Number,
//   },
//   {
//     title: 'Percent',
//     Icon: getIconForFormatType(NumberFormatType.Percent),
//     formatType: NumberFormatType.Percent,
//   },
//   {
//     title: 'Currency',
//     Icon: getIconForFormatType(NumberFormatType.Currency),
//     formatType: NumberFormatType.Currency,
//   },
//   {
//     title: 'Accounting',
//     Icon: getIconForFormatType(NumberFormatType.Accounting),
//     formatType: NumberFormatType.Accounting,
//   },
//   {
//     title: 'Date and Time',
//     Icon: getIconForFormatType(NumberFormatType.DateNTime),
//     formatType: NumberFormatType.DateNTime,
//   },
//   {
//     title: 'Duration',
//     Icon: getIconForFormatType(NumberFormatType.Duration),
//     formatType: NumberFormatType.Duration,
//   },
//   {
//     title: 'Fraction',
//     Icon: getIconForFormatType(NumberFormatType.Fraction),
//     formatType: NumberFormatType.Fraction,
//   },
//   {
//     title: 'Scientific',
//     Icon: getIconForFormatType(NumberFormatType.Scientific),
//     formatType: NumberFormatType.Scientific,
//   },
//   {
//     title: 'Text',
//     Icon: getIconForFormatType(NumberFormatType.Text),
//     formatType: NumberFormatType.Text,
//   },
//   {
//     title: 'Custom',
//     Icon: getIconForFormatType(NumberFormatType.Custom),
//     formatType: NumberFormatType.Custom,
//   },
// ];

export const defaultDateFormats = [
  'YYYY-MM-DD',
  'MMMM D, YYYY',
  'DD/MM/YYYY',
  'DD MMMM, YYYY',
  'D/M/YYYY',
  'dddd, D MMMM YYYY',
];

export const defaultTimeFormats = [
  'hh:mm A',
  'HH:mm',
  'h:mm:ss a',
  'H:mm:ss',
  'hh:mm:ss.SSS',
];

export const defaultDurationFormats = [
  'h:mm:ss',
  'HH:mm:ss',
  'HH:mm',
  'HH',
  'mm',
  'ss',
];

export const defaultFractionFormats = [
  {
    title: 'Up to one digit (1/5)',
    code: '0/0?',
  },
  {
    title: 'Up to two digits (22/25)',
    code: '0/0??',
  },
  {
    title: 'Up to three digits (411/932)',
    code: '0/0???',
  },
];
